import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, List, ListItem } from '@mui/material';
import {default as FlourishOrFateLogo} from '../images/FlourishOrFateIcon.png';
import { EmailLink } from '../components/EmailLink';


export const Home: React.FC = () => {
    return <Grid container>
        <Grid item bgcolor="warning.light" sx={{border: 2, borderColor: 'text.primary', padding: "10px", borderRadius: "8px"}}>
            You are trying to escape the dragon's fire breath.
            You are trying to remember the steps of a particularly difficult dance so the pursuing guards don't know who doesn't belong at this ball.
            You are locked in battle with your rival and former lover.
            There is only one thing to do.
            Make a bold move, or let fortune narrate your next move.
            A flourish, or fate.
        </Grid>
        <Grid item>
            Welcome to Flourish or Fate Games, a one-person game studio.
            Currently, there are two offerings:
            <List>
                <ListItem>a Storytelling Game called <Link to="/plans-in-a-tangle">Plans in a Tangle</Link>, where there are 3 heist teams striking the same museum</ListItem>
                <ListItem>a Table-Top Role Playing Game called <Link to="/dybbuks-and-dreidels">Dybbuks and Dreidels</Link>, inspired by various elements from Jewish folklore</ListItem>
            </List>
            There are <Link to="/upcoming">more in the works</Link>.
            For more inquiries, feel free to reach out to me at <EmailLink />.
        </Grid>
        <Grid item>
            <img src={FlourishOrFateLogo} alt="Flourish or Fate Logo" width="50%"/>
        </Grid>
    </Grid>;
}
